import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import NiftyRegimeConfigDataTable from "./NiftyRegimeConfigDataTable";
import server from "../../../utils/serverConfig";

export default function NiftyRegimeConfig() {
  const [niftyRegimeConfigData, setNiftyRegimeConfigData] = useState([]);
  const [isNiftyConfigDataLoading, setIsNiftyConfigDataLoading] = useState(true);

  const fetchNiftyLotConfigData = () => {
    setIsNiftyConfigDataLoading(true);
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-regime-nifty-config-data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        // console.log("Nifty Regime Config Data", response.data);
        setNiftyRegimeConfigData(response.data.data);
        setIsNiftyConfigDataLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsNiftyConfigDataLoading(false);
      });
  };

  const handleEditNiftyLotConfig = (strategy,optionType,niftyLotConfig) => {
    console.log("strategy", strategy);
    console.log("New Nifty Lot config", niftyLotConfig);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}update-regime-nifty-config-data`,
      data: {
        strategy: strategy,
        optionType:optionType,
        niftyLotConfig: niftyLotConfig,
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        fetchNiftyLotConfigData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchNiftyLotConfigData();

  }, []);

  return (
    <div className="flex flex-col relative  w-full max-h-screen">
      <div className="flex items-center justify-between space-x-4 ">
        <div className="flex justify-between items-center h-[40px] px-6 w-full">
          <p className="flex items-center text-lg font-semibold text-white">
            Nifty Regime Config
          </p>
        </div>
      </div>

      <div className="flex h-full flex-col relative w-full">

      {isNiftyConfigDataLoading ? (
            <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
              loading....
            </div>
          ) : !isNiftyConfigDataLoading && niftyRegimeConfigData.length === 0 ? (
            <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
              No Data Found
            </div>
          ) : (
            <div className="flex min-w-full pt-2">
          <NiftyRegimeConfigDataTable
            niftyRegimeConfigData={niftyRegimeConfigData}
            handleEditNiftyLotConfig={handleEditNiftyLotConfig}
          />
        </div>
          )}
        
      </div>
    </div>
  );
}
